import Container from "@mui/material/Container";
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useEffect } from 'react';
import { API_KEY} from '../../utils/constants';
import { FormControlLabel, Grid, Paper, Stack, Typography, TextField, Switch } from "@mui/material";
import FantasyTable from "./FantasyTable";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import OptimizerTable from "./OptimizerTable";
import Button from "@mui/material/Button";
import FinshedLineups from "./FinishedLineups";
import RemovedNamesTable from "./RemoveNamesTable";
import AddNamesTable from "./AddNamesTable";


export default function FantasyPage() {

    const { id, type} = useParams()
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [optimizedLineup, setOptimizedLineup] = useState([])
    const [isLineupLoading, setIsLineupLoading] = useState(false)
    const [players, setPlayers] = useState([])
    const [removedPlayers, setRemovedPlayers] = useState([]);
    const [addedPlayers, setAddedPlayers] = useState([]);
    const [requestData, setRequestData] = useState({})
    const [maxPts, setMaxPts] = useState(500)
    const [checked, setChecked] = useState(false);
    const [maxLineups, setMaxLineups] = useState(4)


    const handleSelectedRemovedPlayers = (selectedPlayers) => {
      setRemovedPlayers(selectedPlayers);
    };

    const handleSelectedAddedPlayers = (selectedPlayers) => {
      setAddedPlayers(selectedPlayers);
    };
  

    const convertToCsv = () => {
      const csvString = [
        Object.keys(data[0]).join(','),
        ...data.map((row) => Object.values(row).join(',')),
      ].join('\n');
  
      // Create a Blob with the CSV string
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  
      // Create a download link
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'fantasyStats.csv';
      link.click();
  
      // Cleanup
      window.URL.revokeObjectURL(link.href);
    };

    useEffect(() => {
      const fetchData = async () => {
        try {
        setIsLoading(true)
        const response = await axios.get(`${API_KEY}/dkFantasy/${id}`)
        setData(response.data.fantasyList)
        setPlayers(response.data.players)
      }
        catch (error) {
          console.error(error)
        }finally {
          setIsLoading(false)
        }
    }
      fetchData()
    }, [id])

    useEffect(() => {setOptimizedLineup([])}, [id])

    useEffect(() => {setRequestData({data: data, removeNames: removedPlayers, addNames: addedPlayers, use_expected_pts: checked, max_value: maxPts, num_lineups: maxLineups})},
    [data, removedPlayers, addedPlayers, maxPts, checked, maxLineups]) // updates request data FIX THE maxValue on the backend, int doesnt work.

   async function  optimizeLineup() {
    try {
      setIsLineupLoading(true)
      if (type === 'Classic'){
        const response = await axios.post(`${API_KEY}/optimizeClassic`, requestData)
        setOptimizedLineup(response.data)
        console.log(response.data)
      }
      else{
        const response = await axios.post(`${API_KEY}/optimizeCpt`, requestData)
        setOptimizedLineup(response.data)
        console.log(response.data)
      }
      }
      catch (error) {
        console.error(error)
      }finally {
        setIsLineupLoading(false)
        
      }
    }

    function handleSwitchChange() {
      setChecked(!checked)
      console.log(checked)
    }

    function handleMaxLineupsChange(event) {
      setMaxLineups(event.target.value)
    }

    function handleMaxPtsChange(event) {
      setMaxPts(event.target.value)
    }

  return (
    <Container maxWidth="false" sx={{ mt: '10px'}}>
      {data.length > 0 && <Tooltip title="Download CSV" placement='right'>
      <IconButton aria-label="delete" onClick={convertToCsv}>
        <CloudDownloadIcon />
      </IconButton>
      </Tooltip>}
      <Grid container spacing={1}>
        <Grid item md={9} xs={12}>
          <FantasyTable dataInfo={data} type={type} isLoading={isLoading}/>
        </Grid>
        <Grid item md={3} xs={12}>
          <Paper sx={{p: 1}} elevation={3}>
          <Typography variant='h6' align='center'>Optimized Lineup WIP</Typography>
          {isLineupLoading && <Typography variant='h6' align='center'>Loading...</Typography>}
            {optimizedLineup.optimizedLineup && <OptimizerTable isEditable={true} lineup={optimizedLineup.optimizedLineup} fpts={optimizedLineup.totalFpts} salary={optimizedLineup.totalSalary}/>}
          <Stack direction="row" spacing={1} justifyContent='center'>
          <Button variant="outlined" onClick={optimizeLineup}>Optimize</Button>
          </Stack>
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          <RemovedNamesTable players={players} addedPlayers={addedPlayers} id={id} onSelectedPlayersChange={handleSelectedRemovedPlayers}/>
        </Grid>
        <Grid item xs={12} md={4}>
          <AddNamesTable players={players} removedPlayers={removedPlayers} id={id} onSelectedPlayersChange={handleSelectedAddedPlayers}/>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{p: 3, m: 2}} elevation={3}>
          <Stack direction="column" spacing={1} justifyContent='center'>
          <FormControlLabel control={<Switch checked={checked} onChange={handleSwitchChange}/>} label="Use Expected FPTs?"/>
          <Stack direction="row" spacing={1} justifyContent='center'>
            <TextField id="lineups-input" label="Max Lineups" autoComplete="off" type="number" value={maxLineups}  helperText="More lineups can make optimizing slower." onInput={handleMaxLineupsChange}/>
            <TextField id="pts-input" label="Max FPTS" autoComplete="off" type="number" value={maxPts} onInput={handleMaxPtsChange}/>
          </Stack>
          </Stack>
          </Paper>
        </Grid>
      </Grid>
      <FinshedLineups lineups={optimizedLineup} addedPlayers={addedPlayers}/>
    </Container>
  );
}